

const ImageIconItem = function (props) {
    return (
        <div className="imageItem col-4">
            <a href={props.data.ModLinksLink.NavigateUrl}>
                <div className="outerCircle">
                    <div className="innerCircle">
                        <div className="imageWrap">
                            <img src={props.data.ModMobileImage_Url} className="img-fluid mx-auto d-block"/>
                        </div>
                    </div>
                </div>
                <div className="itemTitle">{props.data.Title}</div>
            </a>
        </div>
    );
}
export default ImageIconItem;